import config from '../constants/config';
const isOrganicUtil=()=>{
    return window.location.protocol===new URL(config.API_URL).protocol;
};
export default isOrganicUtil;

